import cn from '../../../common/className.js'

export default function FormListItem({className, hasError, children}) {
  return (
    <li
      className={cn`list__item--form ${className} ${{
        error: hasError,
      }}`}
    >
      {children}
    </li>
  )
}
